import { render, staticRenderFns } from "./Fatal.vue?vue&type=template&id=0916d200&scoped=true&"
import script from "./Fatal.vue?vue&type=script&lang=js&"
export * from "./Fatal.vue?vue&type=script&lang=js&"
import style0 from "./Fatal.vue?vue&type=style&index=0&id=0916d200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916d200",
  null
  
)

export default component.exports